import { render, staticRenderFns } from "./commit.vue?vue&type=template&id=4290377b&scoped=true"
import script from "./commit.vue?vue&type=script&lang=js"
export * from "./commit.vue?vue&type=script&lang=js"
import style0 from "./commit.vue?vue&type=style&index=0&id=4290377b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4290377b",
  null
  
)

export default component.exports